<template>
  <div>
    <h1>Welcome to AutoBook Pro!</h1>
    <div class="q-pa-md q-gutter-sm">
      <div v-if="loadingUser">Loading...</div>
      <div v-else-if="currentUser && browser">
        <q-btn
          color="primary"
          label="Dashboard"
          @click="$router.push({ path: 'dashboard' })"
        ></q-btn>
      </div>
      <div v-else-if="browser">
        <h5 v-if="browser === 'Brave'">
          Please disable the Brave Shields. Otherwise, You cannot log in!
        </h5>
        <q-btn
          color="primary"
          label="Get started"
          @click="handleSignIn"
        ></q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth0 } from '@client/third-party';
import graphql from '@client/graphql';
import { getBrowser } from '@client/utils/browserDetection';
import AppTimeTracker from '@client/utils/app-time-tracker';
import { assessPermission } from '@server/lib/permission-helpers';

export default {
  name: 'Home',
  apollo: {
    currentUser: {
      query: graphql.queries.currentUser,
      watchLoading(isLoading) {
        this.loadingUser = isLoading;
      },
      error(error) {
        this.userError = error;
      },
      result(result) {
        if (result.loading) return;
        if (
          result.data?.currentUser
          && assessPermission.user.canTrackTime(result.data?.currentUser)
        ) {
          AppTimeTracker.init(this.$q);
        }
      }
    },
    notificationsCount: {
      query: graphql.queries.getNotificationsCount
    }
  },
  methods: {
    handleSignIn() {
      Auth0.login('/', {
        allowLogin: true,
        allowSignUp: false
      });
    }
  },
  data() {
    return {
      browser: '',
      loadingUser: false,
      userError: null
    };
  },
  async mounted() {
    this.browser = await getBrowser();
  }
};
</script>
